export var ReviewEventTypes;
(function (ReviewEventTypes) {
    ReviewEventTypes["ReviewAdded"] = "review_added";
    ReviewEventTypes["ReviewChanged"] = "review_changed";
    ReviewEventTypes["ReviewDeleted"] = "review_deleted";
    ReviewEventTypes["AnswerAdded"] = "answer_added";
    ReviewEventTypes["AnswerChanged"] = "answer_changed";
    ReviewEventTypes["AnswerDeleted"] = "answer_deleted";
})(ReviewEventTypes || (ReviewEventTypes = {}));
